import { Component, OnInit, ElementRef, Renderer2 } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { Banner } from "../../shared/models/banner";
import { AuthorizationService } from "../authorization/authorization.service";
import { WindowRef } from '../../utils/window';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";


@Component({
    selector: "div.dtf-faq",
    imports: [SharedTranslateModule],
    templateUrl: './faq.component.html',
    providers: []
})
export class FAQ implements OnInit {
  router: Router;
  isCanadaPortal = false;
  currentCountry: string;
  language = '';
  isFrench = false;
  targetRedirect = '';
  usUrl: string;
  caUrl: string;
  toggleOpen: any;
  public alerts: Banner;
  dbData: any;

  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public dtfhomepageService: DTFHomepageService,
    public translateUtil: TranslateUtil,
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    this.router = router;
  }

  ngOnInit() {
    const language = (window as any).mbfs.language;
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada
    //this.getAlerts();
    this.langInit();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //       for (var i = 0; i < res.length; i++) {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     });
  // }

  ngAfterViewInit() {
    const dropdown = this.el.nativeElement.querySelector('#faq-dropdown');
    dropdown.addEventListener('change', () => {
      const selectedValue = dropdown.value;
      if (selectedValue) {
        const targetSection = this.el.nativeElement.querySelector(selectedValue);
        if (targetSection) {
          targetSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  }
  
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  getPaymentOptionsLink(): string {
    if (this.isFrench) {
        return 'https://daimler-truckfinancial.com/ca/fr/home/paymentOption'; // French URL
    } else {
        return 'https://daimler-truckfinancial.com/ca/en/home/paymentOption'; // English URL
    }
}

getEmailLink(): string {
  const currentLang = this.translate.currentLang;
  if (this.isFrench)  {
    return 'mailto:sfcd@daimlertruck.com'; // French email
  } else {
    return 'mailto:dtf@daimlertruck.com'; // English email
  }
}
getLoginLink(): string {
  const currentLang = this.translate.currentLang;
  if (this.isFrench)  {
      return 'https://daimler-truckfinancial.com/ca/fr/home'; // French URL
  } else {
      return 'https://daimler-truckfinancial.com/ca/en/home'; // English URL
  }
}
getDealerLocatorLink(): string {
  const currentLang = this.translate.currentLang;
  if (this.isFrench)  {
      return 'https://daimler-truckfinancial.com/ca/fr/home/dealerlocator'; // French URL
  } else {
      return 'https://daimler-truckfinancial.com/ca/en/home/dealerlocator'; // English URL
  }
}

}
